import { createBatchingExecutor } from './createBatchingExecutor';
import { memoize2of4 } from './memoize';
export var getBatchingExecutor = memoize2of4(function (_context, executor, dataLoaderOptions, extensionsReducer) {
    var _a;
    if (_context === void 0) { _context = (_a = self !== null && self !== void 0 ? self : window) !== null && _a !== void 0 ? _a : global; }
    return createBatchingExecutor(executor, dataLoaderOptions, extensionsReducer);
});
//# sourceMappingURL=getBatchingExecutor.js.map